<template>
  <v-row>
    <v-col cols="12">
      <v-sheet
        width="100%"
        outlined
        min-height="180px"
      >
        <v-row class="pa-4">

          <v-col class="pl-4" cols="12">
            <h2 class="font-weight-regular">Evaluador:</h2>
          </v-col>

          <v-col cols="12" xl="4" md="4" sm="12">
            <cardSpeaker v-if="!loading" :data="evaluator"/>
          </v-col>
          
        </v-row>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-2 d-flex justify-space-between">
      <v-btn
        depressed
        color="primary"
        :to="{ name: 'evaluatorsEdition', params: { edition_id:this.edition_id }}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

  </v-row>
</template>

<script>
  import axios from 'axios'
  import cardSpeaker from '@/components/card/cardSpeaker'

  export default {
    name: 'showEvaluatorEdition',
    components:{cardSpeaker},

    data: () => ({
      loading:true,

      evaluator:[],

      edition_id: null,
      evaluator_id: null,
    }),

    methods:{
      async getEvaluatorEdition(){
        await axios.get('admin/editions/'+this.edition_id+'/evaluators/'+this.evaluator_id).then(response =>{
          this.evaluator = response.data.data.evaluator
          this.loading=false
        }).catch(error => {
          console.log(error);
        })
      }
    },

    created(){
      this.edition_id = this.$route.params.edition_id
      this.evaluator_id = this.$route.params.evaluator_id
      this.getEvaluatorEdition()
    },
  }
</script>
